/* =====================================================
   ZERO HOUR DRINK — MAIN JAVASCRIPT
   Scroll animations, FAQ, counter, product cards
   (Navbar / hamburger / popup are handled by
    zh-header.liquid and zh-popup.liquid sections.)
   ===================================================== */

// ============================================================
// SCROLL REVEAL — IntersectionObserver
// Wrapped in a function so it can be re-called on section load
// ============================================================
function zhInitReveal() {
  const revealEls = document.querySelectorAll('.reveal-up:not(.visible), .reveal-left:not(.visible)');

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  revealEls.forEach(el => revealObserver.observe(el));
}

document.addEventListener('DOMContentLoaded', () => {
  zhInitReveal();

  // Trigger hero reveals immediately on load
  setTimeout(() => {
    document.querySelectorAll('.hero .reveal-up').forEach(el => {
      el.classList.add('visible');
    });
  }, 100);
});

// Re-init on Shopify section load (design mode)
document.addEventListener('shopify:section:load', zhInitReveal);

// ============================================================
// FAQ ACCORDION
// ============================================================
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');

  // Close all
  document.querySelectorAll('.faq-item.open').forEach(el => {
    el.classList.remove('open');
  });

  // If wasn't open, open it
  if (!isOpen) item.classList.add('open');
}

// ============================================================
// COUNTER ANIMATION for stat numbers
// ============================================================
function animateCounter(el, target, suffix = '') {
  const duration = 1200;
  const start = performance.now();

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
    const current = Math.round(eased * target);
    el.textContent = current + suffix;
    if (progress < 1) requestAnimationFrame(update);
  }
  requestAnimationFrame(update);
}

// Trigger counters when stats come into view
const statObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const statEl = entry.target;
      const text = statEl.textContent.trim();
      if (text.includes('200')) animateCounter(statEl, 200, 'mg');
      else if (text === '0g') animateCounter(statEl, 0, 'g');
      else if (text === '0%') animateCounter(statEl, 0, '%');
      else if (text === '100%') animateCounter(statEl, 100, '%');
      statObserver.unobserve(statEl);
    }
  });
}, { threshold: 0.5 });

document.querySelectorAll('.stat-value, .ms-value').forEach(el => {
  statObserver.observe(el);
});

// ============================================================
// PRODUCT CARD — tilt effect on hover
// ============================================================
document.querySelectorAll('.product-card').forEach(card => {
  card.addEventListener('mousemove', (e) => {
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top)  / rect.height - 0.5;
    card.style.transform = `translateY(-4px) rotateX(${-y * 6}deg) rotateY(${x * 6}deg)`;
    card.style.transition = 'transform 0.1s ease, border-color 0.3s';
  });
  card.addEventListener('mouseleave', () => {
    card.style.transform = '';
    card.style.transition = 'transform 0.4s ease, border-color 0.3s';
  });
});

// ============================================================
// SMOOTH SCROLL for anchor links
// ============================================================
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      const headerEl = document.querySelector('.zh-header-wrap') || document.querySelector('.announcement-bar');
      const offset = headerEl ? headerEl.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  });
});

// ============================================================
// INGREDIENT CARDS — staggered grid animation on scroll
// ============================================================
const ingredientCards = document.querySelectorAll('.ingredient-card');
const ingredientObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }, i * 60);
      ingredientObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

ingredientCards.forEach(card => {
  if (!card.closest('.ingredients-carousel')) {
    // Only animate grid cards, not carousel cards (carousel handles its own state)
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    ingredientObserver.observe(card);
  }
});

// ============================================================
// ACTIVE NAV LINK on scroll
// ============================================================
// const sections = document.querySelectorAll('section[id]');
// const navLinks = document.querySelectorAll('.zh-nav-pill a[href^="#"], .nav-links a');

// window.addEventListener('scroll', () => {
//   let currentId = '';
//   sections.forEach(section => {
//     const sectionTop = section.offsetTop - 120;
//     if (window.scrollY >= sectionTop) currentId = section.id;
//   });

//   navLinks.forEach(link => {
//     link.style.color = '';
//     if (link.getAttribute('href') === '#' + currentId) {
//       link.style.color = 'var(--c-accent, #c8a96e)';
//     }
//   });
// }, { passive: true });
